import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { Link } from 'react-router-dom';

import { ContractItem } from '@/api';
import CardGererContrat from '@/components/CardGererContrat/CardGererContrat';
import CardProduct from '@/components/CardProduct/CardProduct';
import { HIDDEN_PERFORMANCE_GESTIONNAIRE_IDS } from '@/constants/gestionnaire';
import { ROUTE } from '@/constants/route';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

type RouteKey = keyof typeof ROUTE;

type Props = {
  contract: ContractItem;
  onRequestCancellation?: () => void;
};

const ContractGridCard = ({ contract, onRequestCancellation }: Props) => {
  const contractRoute = contract.famille && ROUTE[contract.famille as RouteKey];
  const isPerformanceHidden = HIDDEN_PERFORMANCE_GESTIONNAIRE_IDS.includes(contract.idGestionnaire ?? '');
  const evolution = isPerformanceHidden ? null : contract.evolution;

  return (
    <MtxGrid col={4} colXs={12} colSm={6} colMd={6} colLg={4}>
      {contractRoute ? (
        <Link to={contractRoute.replace(':id', contract.placementId ?? '')}>
          <CardProduct
            family={contract.famille}
            insuranceLogo={contract.gestionnaireLogo ?? ''}
            amount={contract.valorisation?.encours}
            contractName={contract.nomProduit}
            performance={evolution?.performance ?? null}
            gainLoss={evolution?.plusMoinsValue ?? null}
            distributionRate={contract.tauxDistribution}
            status={contract.statut}
            manager={contract.gestionnaire}
            interests={contract.interetsAVenir}
            onClick={() => {
              void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                event_id: 'clic',
                event_categorie: 'clic',
                event_metier: 'espace client placement',
                event_nom: `${contract.famille} - ${contract.nomProduit} `,
                event_detail_1: 'cta',
              });
            }}
          />
        </Link>
      ) : (
        <CardGererContrat
          family={contract.famille}
          insuranceLink={contract.gestionnaireAC ?? ''}
          insuranceLogo={contract.gestionnaireLogo}
          contractName={contract.nomProduit}
          isLogo={true}
          isAsideInfo={false}
          cancelablePeriod={contract.cancelablePeriod}
          onRequestCancellation={onRequestCancellation}
        />
      )}
    </MtxGrid>
  );
};

export default ContractGridCard;
